export enum ResponseType {
  applicationPdf = 'application/pdf',
  imageJpg = 'image/jpeg',
  imagePng = 'image/png',
  imageGif = 'image/gif',
  blob = 'blob',
  arraybuffer = 'arraybuffer',
  applicationXml = 'application/xml',
  textXml = 'text/xml',
}
